import { render, staticRenderFns } from "./TaxExample.vue?vue&type=template&id=33f927a6"
import script from "./TaxExample.vue?vue&type=script&lang=js"
export * from "./TaxExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports